require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-bends-brand-new-website.json") })
        }
      }, "path---news-the-bends-brand-new-website");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-bends-brand-new-website!./.cache/json/news-the-bends-brand-new-website.json
// module id = 849
// module chunks = 231608221292675